<template>
  <div style="background: #fff;width: 100%;padding:0px 10px;">
    <div class="notice-announcement">
      <div class="section-title">
        <span class="line"></span>
        <h2>报奖通知</h2>
        <span class="line"></span>
      </div>
      <!-- <div class="banner-swiper" @mouseenter="stopAuto" @mouseleave="startAuto">
        <div class="swiper-wrapper-banner" :style="{ transform: `translateX(${bannerX}px)`, transition: 'transform 0.4s ease' }">
          <div @click="toItemFn(item)" class="banner-item" v-for="(item, i) in bannerList" :key="i">
            <img :src="`${$baseUrl}/evaluation/api/attachment/preview/${item.coverImageId}`" alt=""  loading="lazy" class="banner-img" />
          </div>
        </div>
        <div class="banner-arrow left" @click="prevBanner"><i class="el-icon-arrow-left"></i></div>
        <div class="banner-arrow right" @click="nextBanner"><i class="el-icon-arrow-right"></i></div>
      </div> -->
        <div class="banner-swiper">
        <div class="swiper-wrapper-banner">
          <div  class="banner-item">
            <img  src="@/assets/images/tzt1.jpg"  loading="lazy" class="banner-img" />
          </div>
        </div>
      </div>
      <div class="latest-notice">
        <div class="notice-header">
          <span class="vertical-line"></span>
          <h3>最新通知</h3>
        </div>
        <div class="notice-two-col">
          <ul class="notice-col">
            <li @click="toItemFn(item)" v-for="(item, idx) in leftList" :key="idx" class="notice-item">
              <span class="dot">•</span>
              <a href="#" class="notice-title">{{ item.title }}</a>
              <span class="notice-date">{{ item.updateTime }}</span>
            </li>
          </ul>
          <ul class="notice-col">
            <li @click="toItemFn(item)" v-for="(item, idx) in rightList" :key="idx" class="notice-item">
              <span class="dot">•</span>
              <a href="#" class="notice-title">{{ item.title }}</a>
              <span class="notice-date">{{ item.updateTime }}</span>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {publishedPage} from '@/api/account';
export default {
  name: "NoticeAnnouncement",
  data() {
    return {
      noticeList: [],
      // 轮播图数据
      bannerList: [],
      bannerX: 0,
      bannerCurrent: 0,
      autoTimer: null,
    };
  },
  computed: {
    leftList() {
      return this.noticeList.filter((_, i) => i % 2 === 0);
    },
    rightList() {
      return this.noticeList.filter((_, i) => i % 2 === 1);
    },
  },
  mounted() {
    this.startAuto();
    this.getList();
  },
  methods: {
    prevBanner() {
      this.bannerCurrent--;
      if (this.bannerCurrent < 0) this.bannerCurrent = this.bannerList.length - 1;
      this.bannerX = -this.bannerCurrent * document.querySelector(".banner-item").offsetWidth;
    },
    nextBanner() {
      this.bannerCurrent++;
      if (this.bannerCurrent >= this.bannerList.length) this.bannerCurrent = 0;
      this.bannerX = -this.bannerCurrent * document.querySelector(".banner-item").offsetWidth;
    },
    startAuto() {
      this.autoTimer = setInterval(this.nextBanner, 3500);
    },
    stopAuto() {
      clearInterval(this.autoTimer);
    },
    toItemFn(item){
        this.$router.push({
          path:'/index/notification/deils',
          query:{
            id:item.notifyId,
          }
        })
    },
     getList(){
       publishedPage({
        typeCode: 2,
        pageSize: 10000000,
        pageNumber: 1,
      }).then((res) => {
        if (res.code == 200) {
          let list = res.data?.pageRecords || [];
          this.noticeList = list.map(item => {
            return {
              ...item,
              content: this.extractText(item.content)
            };
          });
          this.bannerList = this.noticeList.slice(0, 5);
        }
      })
    },
     extractText(html) {
        if (!html) return '';
        let text = html.replace(/<img[^>]*>/g, '');
        text = text.replace(/<[^>]+>/g, '');
        text = text.replace(/\\["nrt]/g, '');
        text = text.trim().replace(/\s+/g, ' ');
        return text;
      },
  },
  beforeDestroy() {
    clearInterval(this.autoTimer);
  },
};
</script>

<style scoped>
.notice-announcement {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  font-family: "Microsoft YaHei", sans-serif;
  background-color: #fff;
}
.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}
.section-title .line {
  width: 120px;
  height: 2px;
  background-color: #0066cc;
}
.section-title h2 {
  font-size: 36px;
  font-weight: 700;
  color: #333;
  margin: 0 20px;
}

.banner-swiper {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
  margin-bottom: 32px;
  border-radius: 4px;
}
.swiper-wrapper-banner {
  display: flex;
  width: 100%;
  height: 100%;
}
.banner-item {
  width: 100%;
  height: 180px;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
}
.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
}
.banner-title {
  font-size: 42px;
  font-weight: 700;
  margin: 0 0 12px;
  color: #fff;
  text-shadow: 0 1px 2px rgba(255,255,255,0.8);
}
.banner-subtitle {
  font-size: 24px;
  margin: 0;
  text-shadow: 0 1px 2px rgba(255,255,255,0.8);
}
.banner-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  background: rgba(0,0,0,0.3);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
}
.banner-arrow.left { left: 16px; }
.banner-arrow.right { right: 16px; }

.latest-notice { width: 100%; }
.notice-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.vertical-line {
  width: 4px;
  height: 24px;
  background-color: #0066cc;
  margin-right: 8px;
}
.notice-header h3 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.notice-two-col {
  display: flex;
  gap: 40px;
  border-top: 2px solid #0066cc;
}
.notice-col {
  flex: 1;
  list-style: none;
  padding: 0;
  margin: 0;
}
.notice-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}
.dot {
  color: #0066cc;
  margin-right: 8px;
  font-size: 14px;
}
.notice-title {
  flex: 1;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.notice-title:hover {
  color: #0066cc;
}
.notice-date {
  font-size: 14px;
  color: #999;
  margin-left: 16px;
}

@media (max-width: 768px) {
  .notice-two-col {
    flex-direction: column;
    gap: 0;
  }
  .banner { height: 140px; }
  .banner-title { font-size: 24px; }
  .banner-subtitle { font-size: 16px; }
}
</style>